import { CubePresenter, Logger } from 'wdc-cube';
import { ConceptScope } from '../../../generic/concept.scope';
import { MonitoringKeys } from './monitoring.key';
import { collaboratorTableModel } from '../collaborators/collaborator-table';
import { Places } from '../../../route-consts';
const LOG = Logger.get('Mormaii.MonitoringPresenter');
/**
 * O CONCEITO "monitoramentos compartilhados", que nao e uma tela.
 *
 * Mesmo desenho de `CollaboratorsPresenter`: passagem, dono do estado comum, e
 * reencaminha quem para nele para a listagem. Ver `ConceptScope`.
 *
 * Aqui o ganho foi maior do que la. A listagem antiga publicava o proprio scope e
 * buscava as linhas SEM condicao - inclusive quando o detalhe era o destino, que
 * entao sobrescrevia o slot logo em seguida. Era uma consulta inteira ao servidor
 * cujo resultado nunca aparecia na tela.
 */
export class MonitoringPresenter extends CubePresenter {
    constructor(app) {
        super(app, new ConceptScope());
        this.at = { criteria: {}, page: 1 };
        /**
         * O modelo da tabela da listagem - a mesma de Colaboradores. Mora no CONCEITO porque
         * a listagem e liberada quando o detalhe abre (sao irmaos), e voltar a ela mediria a
         * tabela de novo. A largura escolhida antes dele, na chave do antigo `ColumnWidths`,
         * e lida na primeira vez.
         */
        this.table = collaboratorTableModel('monitoring', () => this.app.currentSession?.id, {
            widths: 'mormaii.columnWidths:monitoring'
        });
    }
    async applyParameters(intent, initialization, last) {
        const keys = new MonitoringKeys(this.app, intent);
        /*
         * A guarda de papel fica aqui, e nao na listagem.
         *
         * Diferente de `collaborators`: quem alcanca este assunto e o profissional,
         * e as duas telas sao dele. Nao ha o caso do link direto para o detalhe de
         * quem nao tem a lista - aquele leitor entra pela outra montagem.
         */
        if (!(await keys.owner?.allowEntry('monitoring', intent))) {
            return false;
        }
        keys.concept = this;
        this.at = {
            criteria: {
                name: keys.name,
                cpf: keys.cpf,
                periodStart: keys.periodStart,
                periodEnd: keys.periodEnd
            },
            sort: keys.sort,
            page: keys.page
        };
        if (initialization) {
            LOG.info('Initialized');
        }
        if (last) {
            // Ver a nota em `CollaboratorsPresenter`: `redirect` e nao `Keys.of`,
            // porque durante este flip este presenter ainda nao foi comitado.
            await this.app.flipToIntent(intent.redirect(Places.monitoringList));
            return false;
        }
        return true;
    }
    publishParameters(intent) {
        const keys = new MonitoringKeys(this.app, intent);
        keys.name = this.at.criteria.name;
        keys.cpf = this.at.criteria.cpf;
        keys.periodStart = this.at.criteria.periodStart;
        keys.periodEnd = this.at.criteria.periodEnd;
        keys.sort = this.at.sort;
        keys.page = this.at.page;
    }
    /** A listagem mexeu no filtro - ver `CollaboratorsPresenter.moveTo`. */
    moveTo(where) {
        this.at = where;
    }
}
//# sourceMappingURL=monitoring.presenter.js.map